// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"header-module--header-wrap--2Scb3","headerLogo":"header-module--header-logo--3QICi"};